import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";


export const CloseButtonContainer = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 10;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  color: #ff4757;
  font-size: 32px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  transition: all 0.2s;

  &:hover {
    background-color: rgba(255, 71, 87, 0.2);
    color: #ff0022;
  }
`;

// Filter Nav Styled Components (unchanged)
export const FilterNavContainer = styled.div`
  display: flex;
  gap: 8px;
  margin: 20px 0;
  align-items: center;
  flex-wrap: wrap;
`;

export const FilterLabel = styled.span`
  color: #a8b6c9;
  font-size: 14px;
  margin-right: 10px;
`;

export const FilterButton = styled.button`
  background-color: ${(props) => (props.active ? "#0d1627" : "#1a2539")};
  border: ${(props) => (props.active ? "1px solid #3a4c6d" : "none")};
  border-radius: 5px;
  padding: 8px 15px;
  color: #ffffff;
  font-size: 13px;
  cursor: pointer;
`;

export const Dot = styled.span`
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-right: 6px;
  background-color: ${(props) => {
    switch (props.type) {
      case "Cryptocurrency":
        return "#f7931a"; // Bitcoin orange
      case "DeFi Token":
        return "#2775ca"; // DeFi blue
      case "Derivative":
        return "#9c27b0"; // Purple
      case "Exchange Token":
        return "#3f51b5"; // Indigo
      case "Meme Token":
        return "#e91e63"; // Pink
      case "Stablecoin":
        return "#4caf50"; // Green
      case "Staked Token":
        return "#ff5722"; // Deep orange
      case "Synthetic Token":
        return "#607d8b"; // Blue grey
      case "Wrapped Token":
        return "#795548"; // Brown
      default:
        return "transparent";
    }
  }};
`;

// Root Container
export const AppWrapper = styled.div`
  height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: #0c1524;
  color: #ffffff;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
`;

// Container components
export const Container = styled.div`
  width: 100%;
  max-width: 1600px;
  margin: 0 auto;
  padding: 0 15px;
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
  color: #ffffff;
`;

export const SignalsContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  color: #ffffff;
`;

// Header components
export const SignalsHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0;
`;

export const SignalsTitle = styled.h2`
  font-size: 18px;
  font-weight: 500;
  color: #ffffff;
`;

export const SignalsCount = styled.span`
  color: #a8b6c9;
  font-size: 14px;
  margin-left: 8px;
`;

export const ExportButton = styled.button`
  background-color: transparent;
  border: 1px solid #3a4c6d;
  border-radius: 5px;
  padding: 8px 15px;
  color: #ffffff;
  font-size: 13px;
  cursor: pointer;
  display: flex;
  align-items: center;

  svg {
    margin-right: 8px;
  }
`;

// Table container
export const TableContainer = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  border-radius: 5px;
  border: 1px solid #1a2539;
  background-color: #0c1524;
  color: #ffffff;

  &::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #1a2539;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: #3a4c6d;
    border-radius: 4px;
  }

  overflow-x: auto;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  margin-bottom: 0;
  table-layout: fixed;
  color: #ffffff;
`;

export const TableHead = styled.thead`
  position: sticky;
  top: 0;
  z-index: 10;

  tr {
    background-color: #0d1627;
  }
`;

// Updated TableHeader with sorting indicators
export const TableHeader = styled.th`
  text-align: left;
  padding: 12px 15px;
  border-bottom: 1px solid #1a2539;
  color: ${(props) => (props.active ? "#ffffff" : "#a8b6c9")};
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
  padding-right: ${(props) => (props.sortable ? "25px" : "15px")};

  &:hover {
    color: #ffffff;
    background-color: #162235;
  }

  .sort-icon {
    position: absolute;
    right: 8px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 10px;
    opacity: ${(props) => (props.active ? 1 : 0.3)};
    color: ${(props) => (props.active ? "#00bcd4" : "#a8b6c9")};
  }

  &:hover .sort-icon {
    opacity: ${(props) => (props.active ? 1 : 0.7)};
    color: ${(props) => (props.active ? "#00bcd4" : "#ffffff")};
  }
`;

export const SortIcon = styled(FontAwesomeIcon)`
  transition: transform 0.2s ease;
  transform: ${(props) =>
    props.direction === "asc" ? "rotate(0deg)" : "rotate(180deg)"};
`;

// Table body components
export const TableBody = styled.tbody`
  tr,
  td {
    color: #ffffff;
  }
`;

export const TableRow = styled.tr`
  cursor: pointer;
  transition: background-color 0.2s ease;
  
  &:hover {
    background-color: rgba(255, 255, 255, 0.03);
  }
  
  ${props => props.selected && `
    background-color: rgba(0, 188, 212, 0.1) !important;
    border-left: 3px solid #00bcd4;
  `}
`;

export const TableCell = styled.td`
  padding: 15px;
  border-bottom: 1px solid #1a2539;
  font-size: 14px;
  color: #ffffff;
`;

export const SecurityCell = styled(TableCell)`
  font-weight: 600;
  color: #ffffff;
`;

export const DescriptionCell = styled(TableCell)`
  color: #a8b6c9;
  max-width: 250px;
`;

export const SignalBadge = styled.span`
  background-color: ${(props) =>
    props.type === "buy" ? "rgba(0, 188, 212, 0.1)" : "rgba(255, 71, 87, 0.1)"};
  color: ${(props) => (props.type === "buy" ? "#00bcd4" : "#ff4757")};
  padding: 5px 15px;
  border-radius: 3px;
  display: inline-block;
  font-size: 12px;
  font-weight: 600;
`;

export const IndicatorDot = styled.span`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #ff8f00;
  display: inline-block;
`;
